/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".count[_ngcontent-%COMP%]{position:absolute;top:7px;height:15px;width:15px;overflow:hidden;text-align:center;font-size:8px;font-weight:700;line-height:15px;margin-left:7px;display:inline-block;vertical-align:middle}"];
export { styles as styles };
